var exports = {
  "kL": "x31de4314--e7fc50--container",
  "Qs": "x31de4314--e7fc50--content",
  "uQ": "x31de4314--e7fc50--text-group",
  "r7": "x31de4314--e7fc50--image-slot",
};

module.exports = exports;
